import { defineMessages } from 'react-intl';

export const scope = 'cb.containers.BusinessCategoriesField';

export default defineMessages({
  blockHeading: {
    id: `${scope}.blockHeading`,
    defaultMessage: 'Business Categories',
  },
  subcatBlockHeading: {
    id: `${scope}.subcatBlockHeading`,
    defaultMessage: 'Business Sub-Categories',
  },
  instruction: {
    id: `${scope}.instruction`,
    defaultMessage:
      'Please select a category that relate to your business',
  },
  subcatInstruction: {
    id: `${scope}.subcatInstruction`,
    defaultMessage:
      'Please select up to 5 sub-categories that relate to your business',
  },
  atLeastOneMessage: {
    id: `${scope}.atLeastOneMessage`,
    defaultMessage: 'Please select at least one category.',
  },
  entityBusinessCategories: {
    id: `${scope}.entityBusinessCategories`,
    defaultMessage: 'business categories',
  },
});
